import { CookieService } from '@/services/cookie';
import { EXPERIMENT_KEY } from './constants';

const getCurrentExperiment = () => CookieService.getCookie(EXPERIMENT_KEY);

export default {
    getCurrentExperiment,
};
